<div class="subtask-name-input-container">
  <mat-icon svgIcon="subtask" class="subtask-icon"></mat-icon>
  <input
    type="text"
    class="subtask-name-input"
    placeholder="Subtask title"
    [formControl]="$any(controls?.get('title'))"
    autofocus
  />
</div>

<div class="editor-container" #editorContainer [style.maxHeight]="editorContainerMaxHeight + ' !important'">
  <oph-quill-editor
    [bounds]="'.editor-container'"
    [placeholder]="'Instructions'"
    [quillConfig]="quillConfig"
    [inputFC]="$any(controls?.get('body'))"
    [quillStyles]="quillStyles"
  ></oph-quill-editor>

  <div class="input-container" [ngStyle]="inputContainerStyle$ | async" #inputContainer>
    <input type="text" placeholder="Enter caption" #captionInput />
    <button class="input-save-button" (click)="onCaptionSave()">Save</button>
  </div>
</div>

@if (controls?.value?.trackerId) {
  <div class="tracker-container">
    <button class="tracker-name-button" (click)="onConnectTrackerClick('metric')">
      <mat-icon svgIcon="tracker"></mat-icon>
      <span class="tracker-name truncate-text">{{ selectedTracker?.name }}</span>
    </button>
    <div class="tracker-metrics-container">
      <span [class.red]="(controls.value?.metricIds?.length || 0) === 0"
        >{{ controls.value?.metricIds?.length || 0 }} Metrics</span
      >
    </div>
    <oph-x-button (click)="onRemoveTracker()"></oph-x-button>
  </div>
} @else {
  <button
    class="connect-tracker-button"
    (click)="onConnectTrackerClick('tracker')"
    [disabled]="fromTemplate"
    [class.disabled]="fromTemplate"
  >
    <mat-icon svgIcon="tracker"></mat-icon>
    Choose a metric

    <button
      *userHasRoleOption="rolePermissionOptions.Trackers"
      class="new-button"
      (click)="newTracker.emit()"
      [disabled]="fromTemplate"
      [class.disabled-new-button]="newButtonDisabled"
    >
      @if (newButtonLoading) {
        <div class="oph-orange-spinner">
          <mat-spinner [diameter]="23" [strokeWidth]="2"></mat-spinner>
        </div>
      } @else {
        <oph-icon [name]="'plus-orange'" [size]="20"></oph-icon>
        New
      }
    </button>
  </button>
}
